import React, { act, useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import CuModal from "../../../common_component/component/CuModal";
import CuMobileModal from "../../../all-patient/components/CuMobileModal";
import { MobileModalHeader } from "./MobileModalHeader";
import {
  useCreateItem,
  useUpdateItem,
} from "../../../_helper/actions/mutation/items";
import { ApiEndPoint } from "../../../_helper/constant/api-types";
import { toast } from "react-toastify";
import CuSpinner from "../../../common_component/component/CuSpinner";
import { useItemsFilter } from "../../../_helper/actions/app/items";
import { FaTimes } from "react-icons/fa";

export default function PreConsultation({
  isPreconsultation,
  setIsPreconsultation,
}) {
  const sm = !useMediaQuery({ query: "(min-width:1024px)" });
  const closeModal = () => {
    setIsPreconsultation({ data: null, flag: false });
  };

  const [currentTemplate, setCurrentTemplate] = useState({});
  const [formData, setFormData] = useState(
    isPreconsultation?.data?.preconsultation?.answers
      ? isPreconsultation?.data?.preconsultation?.answers
      : {}
  );

  const createMutation = useCreateItem(
    ApiEndPoint.CONSULTATION,
    ApiEndPoint.BOOKING
  );
  const updateMutation = useUpdateItem(
    ApiEndPoint.CONSULTATION,
    ApiEndPoint.BOOKING
  );

  const clinic_id = isPreconsultation?.data?.clinic_id;

  const { data: Questionnaires, isFetched } = useItemsFilter(
    ApiEndPoint.CONSULTATION,
    `?action=getPreconsultationTemplete&clinic_id=${clinic_id}&backend=True`
  );

  // console.log("Questionnaires", Questionnaires);

  useEffect(() => {
    isFetched && setCurrentTemplate(Questionnaires[0]);
  }, [Questionnaires]);

  const handleChange = (questionName, value) => {
    setFormData((prev) => ({
      ...prev,
      [questionName]: value,
    }));
  };

  // console.log("Data", isPreconsultation?.data?.preconsultation);
  const shouldRenderDependentQuestions = (dependentQuestions, parentAnswer) => {
    if (!dependentQuestions) return false;

    if (
      typeof dependentQuestions === "object" &&
      !Array.isArray(dependentQuestions)
    ) {
      return !!dependentQuestions[parentAnswer];
    }

    return true;
  };

  const renderDependentQuestions = (dependentQuestions) => {
    if (!dependentQuestions) return null;

    // Map through the dependent questions and render them
    return dependentQuestions.map((question) => renderQuestion(question));
  };

  const renderQuestion = (question) => {
    const {
      question_id,
      text,
      type,
      options,
      is_required,
      dependent_questions,
    } = question;

    const value = formData[text] || "";

    return (
      <div key={question_id} className="mb-3 mt-2">
        <label className="block font-medium mb-2 text-gray-700">
          {text}
          {is_required && <span className="text-red-500 ml-1">*</span>}
        </label>
        {/* Text and Number Fields */}
        {type === "text" || type === "number" ? (
          <input
            type={type}
            placeholder={`Enter ${text.toLowerCase()}`}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
            required={is_required}
            value={value}
            onChange={(e) => handleChange(text, e.target.value)}
          />
        ) : type === "yes_no" ? (
          /* Yes/No Fields */
          <div className="flex flex-col space-y-2">
            {["yes", "no"].map((val) => (
              <div key={val} className="flex items-center">
                <input
                  type="radio"
                  name={question_id}
                  value={val}
                  className="mr-2"
                  checked={value === val}
                  onChange={(e) => handleChange(text, e.target.value)}
                />
                <label className="text-gray-700">
                  {val.charAt(0).toUpperCase() + val.slice(1)}
                </label>
              </div>
            ))}
            {value &&
              dependent_questions &&
              dependent_questions[value] &&
              renderDependentQuestions(dependent_questions[value])}
          </div>
        ) : type === "dropdown" || type === "dropdown_search" ? (
          /* Dropdown Fields */
          <>
            <select
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
              required={is_required}
              value={value}
              onChange={(e) => handleChange(text, e.target.value)}
            >
              <option value="">Select</option>
              {options?.map((option, index) => (
                <option key={index} value={option.label}>
                  {option.label}
                </option>
              ))}
            </select>
            {options
              ?.find((option) => option.label === value)
              ?.dependent_questions?.map((depQuestion) =>
                renderQuestion(depQuestion)
              )}
          </>
        ) : type === "checkbox_group" || type === "multiple_choice" ? (
          /* Checkbox Group or Multiple Choice */
          <div className="space-y-2">
            {options?.map((option, index) => (
              <div key={index} className="flex flex-col">
                <div className="flex items-center">
                  <input
                    type="checkbox"
                    id={`${question_id}_${index}`}
                    value={option.label}
                    className="mr-2"
                    checked={
                      Array.isArray(value) && value.includes(option.label)
                    }
                    onChange={(e) => {
                      const selectedOptions = Array.isArray(value) ? value : [];
                      const updatedOptions = e.target.checked
                        ? [...selectedOptions, option.label]
                        : selectedOptions.filter((val) => val !== option.label);
                      handleChange(text, updatedOptions);
                    }}
                  />
                  <label
                    htmlFor={`${question_id}_${index}`}
                    className="text-gray-700"
                  >
                    {option.label}
                  </label>
                </div>
                {Array.isArray(value) &&
                  value.includes(option.label) &&
                  renderDependentQuestions(
                    option.dependent_questions,
                    option.label
                  )}
              </div>
            ))}
          </div>
        ) : null}
      </div>
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // console.log("Form Data:", formData);
    if (isPreconsultation?.data?.preconsultation) {
      updateMutation.mutate(
        {
          data: {
            action: "patchPreconsultation",
            id: isPreconsultation?.data?.preconsultation?.id,
            answers: formData,
            clinic_id: isPreconsultation?.data?.clinic_id,
          },
        },
        {
          onSuccess: () => {
            toast.success("Pre-Consultation updated successfully");
            closeModal();
          },
        }
      );
    } else {
      createMutation.mutate(
        {
          answers: formData,
          action: "postPreconsultation",
          clinic_id: isPreconsultation?.data?.clinic_id,
          slot_id: isPreconsultation?.data?.id,
        },
        {
          onSuccess: () => {
            toast.success("Pre-Consultation saved successfully");
            closeModal();
          },
        }
      );
    }
  };

  const allQuestions = currentTemplate?.categories?.flatMap(
    (category) => category.questions
  );

  return (
    <>
      {sm ? (
        <CuMobileModal
          isOpen={isPreconsultation?.flag}
          closeModal={closeModal}
          modalClassName="modal-container-reschedule-appointment h-[90%]"
        >
          <MobileModalHeader>
            <h4 className="text-lg font-bold ">Start a Pre-Consultation</h4>
            <button
              onClick={closeModal}
              className="text-gray-500 hover:text-gray-700 p-2 ml-auto"
              aria-label="Close"
            >
              <FaTimes size={20} />
            </button>
          </MobileModalHeader>
          <form onSubmit={handleSubmit} className="p-4 bg-white rounded-lg">
            {allQuestions?.map((question) => renderQuestion(question))}
            <div className="flex justify-end mt-4">
              <button
                type="submit"
                className="px-4 py-2 bg-green-500 text-white rounded-md hover:bg-green-600"
              >
                Submit
              </button>
            </div>
          </form>
        </CuMobileModal>
      ) : (
        <CuModal closeModal={closeModal} className="h-[85%]">
          <div className="flex">
            <h4 className="text-lg font-bold mt-2">Start a Pre-Consultation</h4>
            <button
              onClick={closeModal}
              className="text-gray-500 hover:text-gray-700 p-2 ml-auto"
              aria-label="Close"
            >
              <FaTimes size={20} />
            </button>
          </div>
          <form
            onSubmit={handleSubmit}
            className="p-4 bg-white rounded-lg overflow-hidden"
          >
            {allQuestions?.map((question) => renderQuestion(question))}
            <div className="flex justify-end mt-4">
              <button
                type="submit"
                className="px-4 py-2 bg-green-500 text-white rounded-md hover:bg-green-600"
              >
                {createMutation.isLoading || updateMutation.isLoading ? (
                  <CuSpinner />
                ) : (
                  "Submit"
                )}
              </button>
            </div>
          </form>
        </CuModal>
      )}
    </>
  );
}
